import { Group, Lock, Public as PublicIcon } from '@mui/icons-material';
import { Grid } from '@mui/material';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useEventContext } from 'src/shared/contexts/eventContext';
import { getEventType } from 'src/shared/functions/getEventType';
import { EventTypeEnum } from 'src/shared/models/enums/eventType.enum';
import { SelectableCard } from 'src/shared/components/form/selectableCard';

interface EventTypeItem {
  name: string;
  description: string;
  eventType: EventTypeEnum;
  icon: JSX.Element;
}

const eventTypeArray: EventTypeItem[] = [
  {
    name: 'event:eventType.public',
    description: 'event:eventType.publicDescription',
    eventType: EventTypeEnum.Public,
    icon: <PublicIcon className='icon' />,
  },
  {
    name: 'event:eventType.nonPublic',
    description: 'event:eventType.nonPublicDescription',
    eventType: EventTypeEnum.NonPublic,
    icon: <Group className='icon' />,
  },
  {
    name: 'event:eventType.onlyMembers',
    description: 'event:eventType.onlyMembersDescription',
    eventType: EventTypeEnum.OnlyMembers,
    icon: <Lock className='icon' />,
  },
];

export const EventTypeSelector = () => {
  const { t } = useTranslation();
  const { setValue, getValues } = useFormContext();

  const { selectedEventType = undefined, setSelectedEventType } = useEventContext();

  useEffect(() => {
    if (selectedEventType === EventTypeEnum.Public) {
      setValue('publicSignUp', true);
      setValue('membersOnly', false);
    }
    if (selectedEventType === EventTypeEnum.NonPublic) {
      setValue('publicSignUp', false);
      setValue('membersOnly', false);
    }
    if (selectedEventType === EventTypeEnum.OnlyMembers) {
      setValue('publicSignUp', false);
      setValue('membersOnly', true);
    }
  }, [selectedEventType, setValue]);

  useEffect(() => {
    const publicSignUp = getValues('publicSignUp');
    const membersOnly = getValues('membersOnly');
    const eventType = getEventType(publicSignUp, membersOnly);
    setSelectedEventType(eventType);
  }, [getValues, setSelectedEventType]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          {eventTypeArray.map((exp) => (
            <Grid item xs={12} md={4} key={exp.eventType}>
              <SelectableCard
                selected={selectedEventType === exp.eventType}
                onClick={() => setSelectedEventType(exp.eventType)}
                icon={exp.icon}
                title={t(exp.name)}
                description={t(exp.description)}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};
